import { UiStore } from 'app/store/lib/uiStore';
import { AuthStore } from './lib/authStore';
import { ExplorerStore } from 'app/store/lib/explorers/explorerStore';
import { SectionStore } from './lib/sectionStore';
import { StateStore } from 'app/store/lib/stateStore';
import { makeAutoObservable, runInAction } from 'mobx';
import { NotificationsStore } from 'app/store/lib/notificationsStore';
import { AdminRequestsStore } from 'app/store/lib/adminRequestsStore';
import { AdminUsersStore } from 'app/store/lib/adminUsersStore';
import { SearchStore } from 'app/store/lib/searchStore';
import { TrashExplorerStore } from 'app/store/lib/explorers/trashExplorerStore';

export class RootStore {
  // @ts-ignore
  uiStore: UiStore;
  // @ts-ignore
  authStore: AuthStore;
  // @ts-ignore
  explorerStore: ExplorerStore;
  // @ts-ignore
  trashExplorerStore: TrashExplorerStore;
  // @ts-ignore
  sectionStore: SectionStore;
  // @ts-ignore
  stateStore: StateStore;
  // @ts-ignore
  notificationsStore: NotificationsStore;
  // @ts-ignore
  adminRequestsStore: AdminRequestsStore;
  // @ts-ignore
  adminUsersStore: AdminUsersStore;
  // @ts-ignore
  searchStore: SearchStore;

  explorerPageKey: string = String(Math.random());

  constructor() {
    runInAction(() => {
      this.uiStore = new UiStore({ rootStore: this });
      this.authStore = new AuthStore({ rootStore: this });
      this.explorerStore = new ExplorerStore({ rootStore: this });
      this.trashExplorerStore = new TrashExplorerStore({ rootStore: this });
      this.sectionStore = new SectionStore({ rootStore: this });
      this.stateStore = new StateStore({ rootStore: this });
      this.notificationsStore = new NotificationsStore({ rootStore: this });
      this.adminRequestsStore = new AdminRequestsStore({ rootStore: this });
      this.adminUsersStore = new AdminUsersStore({ rootStore: this });
      this.searchStore = new SearchStore({ rootStore: this });
    });
    makeAutoObservable(this);
  }

  generateExplorerPageKey() {
    this.explorerPageKey = String(Math.random());
  }
}

const mobxStore = new RootStore();
export default mobxStore;
